import styled, { createGlobalStyle } from "styled-components";
import { Input, Select } from "@renderbus/ui";

export const PaymentWayWrapper = styled.div`
  margin-top: 20px;
  background: #292b2f;
  border-radius: 8px;
  padding: 11px 20px 15px;
  .stripe-box,
  .paypal-box {
    display: flex;
    justify-content: space-between;

    span:nth-child(2) {
      flex: 1;
      display: flex;
      justify-content: space-between;
    }
  }

  .paypal-box {
    .paypal-label,
    .card-icons {
      display: flex;
      align-items: center;
    }
  }

  .stripe-box {
    .flex {
      display: flex;
      align-items: center;

      .pay-text {
        margin-right: 4px;
      }

      .recommended {
        color: #e4f6ff;
        font-size: 12px;
        white-space: nowrap;
      }
    }
  }
`;

export const DebitCardRadioContent = styled.span`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 2px 0 0;
  color: #e4f6ff;

  svg {
    flex-shrink: 0;
  }

  .entry-text {
    font-size: 12px;
    font-weight: 600;
  }
`;

export const QRCodeContainer = styled.div`
  margin-right: 24px;
  width: 130px;
  height: 130px;
  border-radius: 6px;
  background: #2c2c31;
  border: 1px solid #495359;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WechatContent = styled.div`
  display: flex;
  align-items: center;
  background: rgba(35, 35, 37, 1);
  padding: 20px;
  border-radius: 10px;
`;

export const RadioPayContainer = styled.div`
  display: flex;
  align-items: self-end;
  margin-top: 20px;
  .pay-radio {
    .pay-text {
      color: #e4f6ff;
      font-size: 12px;
      margin: 0 22px 0 4px;
    }
    .payment-icon {
      width: 14px;
      height: 14px;
    }
    .pay-icon {
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }
    .recharge-button {
      color: #e0edef;
      border-color: transparent;
      width: 229px;
      height: 40px;
      line-break: 40px;
      background: #f3512b;
      border-radius: 4px;
      margin-top: 34px;
      font-weight: 600;
      transition: none;
      &.wechat-recharge {
        margin-top: 0px;
        width: auto;
        height: 28px;
        line-height: 28px;
        padding: 5px 14px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 12px;
      }
    }
    .renderbus-ui--radio {
      min-width: 300px;
      width: 100%;
      height: 46px;
      border: 1px solid #495359;
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      .ant-radio-inner {
        width: 14px;
        height: 14px;
      }
      .ant-radio.ant-radio-checked .ant-radio-inner {
        background: #f3512b;
        border-color: #f3512b;
      }
      .ant-radio .ant-radio-inner::after {
        background: #ffffff;
        transform: scale(0.475);
      }
      &.ant-radio-wrapper-checked {
        border: 2px solid #f3512b;
        background: #212327;
      }
    }
  }
`;
export const ForeginQRCodeContainer = styled(QRCodeContainer)`
  height: 121px;
  width: 121px;
  img {
    width: 121px;
    height: 121px;
    border-radius: 6px;
  }
`;

export const RechargeBtnContent = styled.div`
  p {
    margin: 0;
    color: #d4d4d4;
    font-size: 12px;
  }

  .recharge-button {
    color: #e0edef;
    border-color: transparent;
    width: 229px;
    height: 40px;
    line-break: 40px;
    background: #f3512b;
    border-radius: 4px;
    margin-top: 34px;
    font-weight: 600;
    transition: none;
  }

  .scan-text {
    font-weight: 600;
  }
  .title {
    color: #e5e5e5;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }
`;

export const DebitCardActionContent = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    margin: 0;
  }
`;

export const DebitCardModalStyle = createGlobalStyle`
  .debit-card-modal.renderbus-ui--modal {
    .ant-modal-content,
    .ant-modal-body {
      background: #ffffff !important;
    }

    .ant-modal-content {
      box-shadow: none !important;
      border-radius: 6px !important;
    }

    .ant-modal-body {
      padding: 0 !important;
      min-height: unset !important;
    }

    .ant-modal-footer {
      display: none !important;
      padding: 0 !important;
      background: transparent !important;
    }
  }
`;

export const DebitCardModalContent = styled.section`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 335px;
  margin: 0 auto;
  padding: 0;
  background: #ffffff;
  border-radius: 6px;

  .modal-header {
    min-height: 46px;
    background: #ffffff;
    border-radius: 6px;
    padding: 0 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-header-paypal {
    padding: 10px 44px;
    justify-content: center;
  }

  .modal-header-main {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    min-width: 0;
    margin: 0 auto;
  }

  .modal-title {
    margin: 0;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.76;
  }

  .close-button {
    border: 0;
    background: transparent;
    color: #6b7280;
    width: 16px;
    height: 16px;
    padding: 0;
    position: absolute;
    right: 16px;
    top: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
  }

  .modal-form-panel {
    background: #242424;
    border-radius: 6px;
    padding: 34px 18px;
    min-height: 260px;
    box-sizing: border-box;
  }

  .modal-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 300px;
    margin: 0 auto;
  }

  .field-row {
    display: grid;
    grid-template-columns: 149px 139px;
    gap: 12px;
  }

  .field-label {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .field-highlight {
    position: relative;
  }

  .section-title {
    margin: 4px 0 -2px;
    color: #ffffff;
    font-size: 14px;
    line-height: 1.2;
  }

  .amount-text {
    margin: 0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
  }

  .helper-text {
    margin: 0;
    color: #c5c5c5;
    font-size: 12px;
    line-height: 1.5;

    &.muted {
      color: #929292;
    }
  }

  .paypal-button-container {
    min-height: 42px;

    > div {
      width: 100%;
    }
  }

  .paypal-bcdc-container {
    flex: 1;
    width: 100%;
    min-height: 40px;
    overflow: visible;

    > div {
      width: 100%;
    }
  }

  .paypal-bcdc-container-wrapper {
    flex: 1;
    width: 100%;
    position: relative;
    min-height: 40px;
    margin: 0 auto;
  }

  .paypal-bcdc-container-wrapper.sdk-loading .paypal-bcdc-container {
    opacity: 0;
  }

  .paypal-bcdc-loading {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 40px;
    border-radius: 6px;
    background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
    background-size: 200% 100%;
    animation: paypal-loading-shimmer 1.2s ease-in-out infinite;
  }

  @keyframes paypal-loading-shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  .paypal-field-frame {
    width: 100%;
  }

  .paypal-field-container {
    width: 100%;
    height: 40px;
    border-radius: 6px;
    border: 2px solid transparent;
    background: #303030;
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    &:empty::before {
      content: attr(data-placeholder);
      color: #929292;
      font-size: 12px;
      line-height: 1;
      pointer-events: none;
    }
  }

  .status-message {
    margin: 0;
    color: #e7d08c;
    font-size: 12px;
    line-height: 1.5;
  }

  .status-error,
  .status-cancelled {
    color: #ff8e8e;
  }

  .modal-footer {
    width: 335px;
    margin: 0 auto;
  }

  .modal-footer .renderbus-ui--button.ant-btn {
    width: 100%;
    height: 40px;
    background: #fd5c1f !important;
    border-color: transparent;
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    border-radius: 6px;
    margin-top: 0;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 40px;
    box-shadow: none;
  }
`;

export const DebitCardFieldInput = styled(Input)`
  &.renderbus-ui--input {
    width: 100%;
    height: 40px;
    border-radius: 6px;
    border: 2px solid transparent;
    background: #303030;
    color: #ffffff;
    font-size: 12px;
    padding: 0 16px;
    box-shadow: none;

    &::placeholder {
      color: #929292;
      font-size: 12px;
    }

    &:hover {
      border-color: transparent;
      box-shadow: none;
    }

    &:focus,
    &:active {
      border-color: #f3512b;
      box-shadow: none;
    }
  }
`;

export const DebitCardFieldSelect = styled(Select)`
  &.renderbus-ui--select {
    width: 100%;
    min-width: 300px;
    height: 40px;
    background: #303030;
    border: 2px solid transparent;
    border-radius: 6px;
    box-shadow: none;

    &:hover,
    &:active {
      box-shadow: none;
    }

    &.ant-select-open,
    &:focus-within {
      border-color: #f3512b;
    }

    .ant-select-selector {
      height: 36px !important;
      padding: 0 16px !important;
      background: #303030 !important;
      border-radius: 4px !important;
      display: flex;
      align-items: center;
      box-shadow: none !important;
    }

    .ant-select-selection-placeholder,
    .ant-select-selection-item {
      color: #929292 !important;
      font-size: 12px !important;
      line-height: 36px !important;
    }

    .ant-select-arrow {
      color: #ffffff;
      right: 16px;
      font-size: 10px;
    }
  }
`;
